/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */

App.ready(() => App.dateranges.init());

App.dateranges = {
  init() {
    return $(".js-daterange-btn")
      .off("click", App.dateranges.update_range)
      .on("click", App.dateranges.update_range);
  },

  update_range(evt) {
    evt.preventDefault();
    const $wrapper        = $(evt.target).closest(".dropdown-select");
    const $starts_on      = $wrapper.find(".js-daterange-starts-on");
    const $ends_on        = $wrapper.find(".js-daterange-ends-on");
    const starts_on_label = $starts_on.val();
    const ends_on_label   = $ends_on.val();
    const starts_on_value = $starts_on.pickadate("_hidden").value;
    const ends_on_value   = $ends_on.pickadate("_hidden").value;

    if (starts_on_value && ends_on_value) {
      $(".js-daterange-range-display").text(`${starts_on_label} - ${ends_on_label}`);
      $(".js-daterange-hidden-starts-on").val(starts_on_value);
      $(".js-daterange-hidden-ends-on").val(ends_on_value);
      return $wrapper.closest("form").submit();
    }
  }
};
